import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  private baseUrl = `${environment.apiUrl}/api/`;

  constructor(private http: HttpClient) { }

  get<T>(controller: string, action: string): Observable<T> {
    return this.http.get<T>(`${this.baseUrl}${controller}/${action}`);
  }

  post<T>(controller: string, action: string, data: any): Observable<T> {
    return this.http.post<T>(`${this.baseUrl}${controller}/${action}`, data);
  }

}